import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { forwardRef as f } from "react";
const t = ({
  title: r,
  titleId: i,
  ...e
}, h) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: h, "aria-labelledby": i, ...e, children: [
  r ? /* @__PURE__ */ l("title", { id: i, children: r }) : null,
  /* @__PURE__ */ l("rect", { width: 24, height: 24, fill: "#fcff52", rx: 12 }),
  /* @__PURE__ */ l("path", { fill: "#000", d: "M18 6H6v12h12v-4.189h-1.992a4.4 4.4 0 0 1-4 2.592 4.42 4.42 0 0 1-4.412-4.412c0-2.42 1.975-4.394 4.413-4.394 1.802 0 3.347 1.099 4.034 2.66H18z" })
] }), d = f(t);
export {
  d as default
};
//# sourceMappingURL=celo.js.map
